import { postJSON } from '@/lib/api'

export function submitDonation(form: {
  contactId: string
  amount: string
  giftOn: string
  paymentType: 'cash' | 'check'
  checkNumber: string
  idempotencyKey: string
  campaignId: string
  tributeType: 'honor' | 'memory' | null
  honoreeName: string
  displayAnonymous: boolean
  sendReceipt: boolean
}) {
  return postJSON<{ donation: { id: number } }>('/api/v1/donations', {
    donation: {
      contact_id: Number(form.contactId),
      amount: form.amount,
      gift_on: form.giftOn,
      payment_type: form.paymentType,
      check_number: form.paymentType === 'check' ? form.checkNumber : null,
      idempotency_key: form.idempotencyKey,
      campaign_id: form.campaignId ? Number(form.campaignId) : null,
      tribute_type: form.tributeType,
      honoree_name: form.tributeType ? form.honoreeName || null : null,
      display_anonymous: form.displayAnonymous,
      send_receipt: form.sendReceipt,
    },
  })
}
